export const RELAY_WIDTH = 360;

export const AVATAR_VISUALS = {
  'neon-relay': {
    textureKey: 'neon-relay-avatar-courier',
    assetPath: '/game-icons/neon-relay.png',
    accent: 0xffd166,
    trail: 0x57d8ff,
    name: 'Courier',
  },
  'neon-relay-pulse': {
    textureKey: 'neon-relay-avatar-pulse',
    assetPath: '/game-icons/neon-relay-pulse.png',
    accent: 0x7af7b2,
    trail: 0x57d8ff,
    name: 'Pulse',
  },
  'neon-relay-sprinter': {
    textureKey: 'neon-relay-avatar-sprinter',
    assetPath: '/game-icons/neon-relay-sprinter.png',
    accent: 0xffd166,
    trail: 0xff5f7a,
    name: 'Sprinter',
  },
};

export const ITEM_VISUALS = {
  packet: {
    label: 'Data packet',
    shape: 'parcel',
    symbol: 'address-stripe',
    primary: 0x57d8ff,
    secondary: 0xffd166,
    ink: 0x101a2b,
    outline: 0xf7fbff,
  },
  boost: {
    label: 'Relay boost',
    shape: 'battery-cell',
    symbol: 'lightning-core',
    primary: 0x7af7b2,
    secondary: 0xfff3b0,
    ink: 0x102a24,
    outline: 0xf7fbff,
  },
  blocker: {
    label: 'Signal blocker',
    shape: 'warning-gate',
    symbol: 'crossbar',
    primary: 0xff5f7a,
    secondary: 0xffd166,
    ink: 0x101a2b,
    outline: 0xf7fbff,
  },
};

export const ROUTE_THEMES = {
  midtown: {
    label: 'City Core',
    background: 0x050914,
    laneA: 0x071629,
    laneB: 0x091b30,
    accent: 0xffd166,
    secondary: 0x57d8ff,
    horizon: 0x10223a,
    sign: 'MID',
  },
  market: {
    label: 'Signal Market',
    background: 0x071018,
    laneA: 0x0b1b22,
    laneB: 0x102029,
    accent: 0x7af7b2,
    secondary: 0xffd166,
    horizon: 0x153527,
    sign: 'MKT',
  },
  glassway: {
    label: 'Glassway',
    background: 0x070d1f,
    laneA: 0x0c1630,
    laneB: 0x101c38,
    accent: 0x57d8ff,
    secondary: 0xf7fbff,
    horizon: 0x1a2f54,
    sign: 'GLS',
  },
  uplink: {
    label: 'Last Uplink',
    background: 0x0f0814,
    laneA: 0x180d1f,
    laneB: 0x201026,
    accent: 0xff5f7a,
    secondary: 0xffd166,
    horizon: 0x35152e,
    sign: 'UPL',
  },
};

export function getAvatarVisual(selectedPlayableIcon = 'neon-relay') {
  return AVATAR_VISUALS[selectedPlayableIcon] ?? AVATAR_VISUALS['neon-relay'];
}

export function getRouteTheme(route = {}) {
  return ROUTE_THEMES[route.themeId] ?? ROUTE_THEMES.midtown;
}
